import { Routes } from '@angular/router';
import { DefaultLayoutComponent } from './layout';
import { DashboardResolver } from './resolvers/dashboard.resolver';

// add this to some section to trigger the resolver and the closure of the splash screen
// import { DashboardResolver } from './resolvers/dashboard.resolver';
// resolve: {'itemsList': DashboardResolver},
// //   {
//     path: '',
//     redirectTo: 'tracker',
//     pathMatch: 'full',
//   },
export const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home',
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./views/dashboard/routes').then((m) => m.routes),
      },
      {
        path: 'tracker',
        loadChildren: () =>
          import('./views/dashboard/routes').then((m) => m.routes),
      },
      {
        path: 'market',
        loadChildren: () =>
          import('./views/market/routes').then((m) => m.routes),
      },
      {
        path: 'market/:code',
        loadChildren: () =>
          import('./views/market/routes').then((m) => m.routes),
      },
      {
        path: 'contracts',
        loadChildren: () =>
          import('./views/contracts/routes').then((m) => m.routes),
      },
      {
        path: 'posts',
        loadChildren: () =>
          import('./views/trades/routes').then((m) => m.routes),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./views/profiles/profile/profile.component').then(
            (m) => m.ProfileComponent
          ),
        data: {
          title: 'Profile',
        },
      },
      {
        path: 'rulebook',
        loadChildren: () =>
          import('./views/rulebook/routes').then((m) => m.routes),
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./views/notification-history/notification-history.component').then(
            (m) => m.NotificationHistoryComponent
          ),
        data: {
          title: 'Notification History',
        },
      },
      {
        path: '',
        redirectTo: 'tracker',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'messaging',
    loadComponent: () =>
      import('./components/messaging/messaging.component').then(
        (m) => m.MessagingComponent
      ),
    data: {
      title: 'FCM',
    },
  },
  {
    path: 'login-return',
    loadComponent: () =>
      import('./views/login/login-return/login-return.component').then(
        (m) => m.LoginReturnComponent
      ),
    data: {
      title: 'Login Return',
    },
  },
  {
    path: 'payment-success',
    loadComponent: () =>
      import('./views/pages/payment-success/payment-success.component').then(
        (m) => m.PaymentSuccessComponent
      ),
    data: {
      title: 'Payment Recorded',
    },
  },
  {
    path: '404',
    loadComponent: () =>
      import('./views/pages/page404/page404.component').then(
        (m) => m.Page404Component
      ),
    data: {
      title: 'Page 404',
    },
  },
  {
    path: '500',
    loadComponent: () =>
      import('./views/pages/page500/page500.component').then(
        (m) => m.Page500Component
      ),
    data: {
      title: 'Page 500',
    },
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./views/register/register.component').then(
        (m) => m.RegisterComponent
      ),
    data: {
      title: 'Register',
    },
  },
  {
    path: 'official-forms',
    loadChildren: () => import('./fulfill-docs/routes').then((m) => m.routes),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./views/login/login.component').then((m) => m.LoginComponent),
    data: {
      title: 'Login',
    },
  },
  {
    path: 'login/*',
    loadComponent: () =>
      import('./views/login/login.component').then((m) => m.LoginComponent),
    data: {
      title: 'Login',
    },
  },
  {
    path: 'logout',
    loadComponent: () =>
      import('./views/logout/logout.component').then((m) => m.LogoutComponent),
    data: {
      title: 'Logout',
    },
  },
  {
    path: 'test-login',
    loadComponent: () =>
      import('./views/test-login/test-login.component').then((m) => m.TestLoginComponent),
    data: {
      title: 'Test Login',
    },
  },
  {
    path: 'routing-select',
    loadComponent: () =>
      import('./views/stockpoint/routing-select/routing-select.component').then(
        (m) => m.RoutingSelectComponent
      ),
    data: {
      title: 'Routing Select',
    },
  },
  {
    path: 'verify/:receiptNumber',
    loadComponent: () =>
      import('./views/warehouse-receipt/verify/verify.component').then(
        (m) => m.VerifyComponent
      ),
    data: {
      title: 'Verify Receipt',
    },
  },
  { path: '**', redirectTo: 'dashboard' },
];
